const dictionary = {
    EN: {
        ADMIN: 'Admin',
        FLEET_OWNER: 'Fleet owner',
        TECHNICIAN: 'Technician',
        EXTERNAL: 'External worker',
        RED: 'currently in ride +30km/h',
        YELLOW: 'currently in ride +15km/h',
        GREEN: 'currently in ride',
        GREY: 'postój',
        carStatus: 'Car status',
        carCategory: 'Car category',
        fleet: 'Fleet',
        ACTIVE: 'Active',
        NOT_ACTIVE: 'Not Active',
        TURNED_OFF: 'Turned off',
        NO_ACTIVITY: 'No Activity',
        BLOCKED: 'Blocked',
        TODAY: 'Today',
        YESTERDAY: 'Yesterday',
        THIS_WEEK: 'This week',
        LAST_WEEK: 'Last week',
        THIS_MONTH: 'This month',
        LAST_MONTH: 'Last month',
        THIS_YEAR: 'This year',
        LAST_YEAR: 'Last year',
        NEW: 'New',
        INSTALLATION_DATE_CONFIRMED: 'Installation date confirmed',
        INSTALLATION_FINISHED: 'Installation finished',
        CANCELLED: 'Cancelled',
        INSTALLATION_FINISH_CONFIRMED: 'Installation confirmed',
        INSTALLATION_CONFIRMED: 'Installation confirmed',
        CAR_TOW: 'Car tow',
        CAR_COLLISION: 'Car collision',
        EU_BORDER_CLOSENESS: 'Eu border closeness',
        type: 'Type',
        description: 'Description',
        policyConstraint: 'The installer must have a valid insurance policy on the day of installation',
        LOGIN_ERROR_MESSAGE: 'Incorrect email or password.',
        LOGIN_NOT_PERMISSION_ERROR_MESSAGE: 'Valid login data but not permissions to log in. Use dedicate mobile app!',
        LOGIN_ALBATROSS_USER_MESSAGE: 'You do not have permission to view this page',
        LOGIN_MIGRATION_USE_VEHIS_PASSWORD_MESSAGE: 'Incorrect login or password. Use your VEHIS customer panel login details. If the problem persists, contact customer support.',
        LOGIN_MIGRATION_REDIRECT_INFO: 'After logging in you will be redirected to the new version of the web panel.',
        INSTRUCTION: 'Instruction',
        CAR_BOUGHT_BY_CLIENT: 'Car bought by client',
        CONTRACT_CANCELLED_WITHOUT_PURCHASE: 'Contract cancelled without purchuase',
        DEBT_COLLECTION_REPOSSESSION: 'Debt collection repossession',
        OTHER: 'Other',
        THEFT: 'Theft',
        TOTAL_LOSS: 'Total loss',
        FLEET_REMOVE_SUCCESS: 'Fleet successful deleted'
    },
    PL: {
        ADMIN: 'Administrator',
        FLEET_OWNER: 'Właściciel floty',
        TECHNICIAN: 'Monter terminali GPS',
        EXTERNAL: 'Pracownik zewnętrzny',
        RED: 'w trasie +30km/h',
        YELLOW: 'w trasie +15km/h',
        GREEN: 'w trasie',
        GREY: 'postój',
        carStatus: 'Status pojazdu',
        carCategory: 'Kategoria pojazdu',
        fleet: 'Flota',
        ACTIVE: 'Aktywny',
        NOT_ACTIVE: 'Nieaktywny',
        TURNED_OFF: 'Wyłączony',
        NO_ACTIVITY: 'Brak aktywności',
        BLOCKED: 'Zablokowany',
        TODAY: 'Dzisiaj',
        YESTERDAY: 'Wczoraj',
        THIS_WEEK: 'Bieżący tydzień',
        LAST_WEEK: 'Poprzedni tydzień',
        THIS_MONTH: 'Bieżący miesiąc',
        LAST_MONTH: 'Poprzedni miesiąc',
        THIS_YEAR: 'Bieżący rok',
        LAST_YEAR: 'Poprzedni rok',
        NEW: 'Nowy',
        INSTALLATION_DATE_CONFIRMED: 'Zaplanowane',
        INSTALLATION_FINISHED: 'Zakończone',
        CANCELLED: 'Anulowane',
        INSTALLATION_FINISH_CONFIRMED: 'Potwierdzone',
        INSTALLATION_CONFIRMED: 'Potwierdzone',
        CAR_TOW: 'Holowanie pojazdu',
        CAR_COLLISION: 'Wypadek',
        EU_BORDER_CLOSENESS: 'Zbliżenie do granic UE',
        type: 'Typ',
        description: 'Opis',
        policyConstraint: 'Monter musi mieć ważną polise w dniu montażu',
        LOGIN_ERROR_MESSAGE: 'Niewłaściwy e-mail lub hasło',
        LOGIN_NOT_PERMISSION_ERROR_MESSAGE: 'Dane logowania prawidłowe, ale brak uprawnień to zalogowania się. Proszę użyć dedykowanej aplikacji mobilnej!',
        LOGIN_ALBATROSS_USER_MESSAGE: 'Nie masz uprawnień by oglądać zawartość tej strony',
        LOGIN_MIGRATION_USE_VEHIS_PASSWORD_MESSAGE: 'Błędny login lub hasło. Użyj danych logowania z panelu klienta VEHIS. Jeśli problem będzie się powtarzał, skontaktuj się z Biurem Obsługi Klienta.',
        LOGIN_MIGRATION_REDIRECT_INFO: 'Po zalogowaniu zostaniesz przekierowany do nowej wersji panelu web.',
        INSTRUCTION: 'Instrukcja',
        CAR_BOUGHT_BY_CLIENT: 'Klient wykupił samochód',
        CONTRACT_CANCELLED_WITHOUT_PURCHASE: 'Umowa anulowana bez zakupu',
        DEBT_COLLECTION_REPOSSESSION: 'Windykacja',
        OTHER: 'Inne',
        THEFT: 'Kradzież',
        TOTAL_LOSS: 'Szkoda całkowita',
        FLEET_REMOVE_SUCCESS: 'Flota pomyślnie usunięta'
    }
};

export default dictionary;



// WEBPACK FOOTER //
// ./src/Translations/Dictionary.ts